<template>
  <div id="app">
   <wpheader></wpheader>
    <router-view/>
  </div>
</template>

<script>
import wpheader from './components/global/Header.vue'

export default {
  name: 'App',

  components: {
    wpheader
  }
}
</script>

<style src="./assets/styles/main.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue